import { CompanyLinkType } from '@api';
import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormActions } from '../../../FormActions';
import { useCompanyLinkFormSchema } from '../../hooks';
import { CompanyLinkFormValuesType } from '../../types';

type RootPropsType = {
  companyLink?: CompanyLinkType;
  handleSubmit: (data: CompanyLinkFormValuesType) => void;
  onCancel: () => void;
  children: React.ReactNode;
};

export const Root: React.FC<RootPropsType> = ({
  companyLink,
  handleSubmit,
  onCancel,
  children,
}) => {
  const { schema, defaultValues } = useCompanyLinkFormSchema({ companyLink });

  const methods = useForm<CompanyLinkFormValuesType>({
    resolver: zodResolver(schema),
    defaultValues,
  });
  const { reset } = methods;
  const { t } = useTranslation();

  const handleCancel = () => {
    reset(defaultValues);
    onCancel();
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Stack gap="xl" data-testid="company-link-form">
          {children}
          <FormActions
            onCancel={handleCancel}
            saveButtonText={t('SAVE_BUTTON')}
            cancelButtonText={t('CANCEL_BUTTON')}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
